import { app_url } from "app_config"
import Breadcrumb from "components/Common/Breadcrumb"
import { axiosbaseurl } from "configure"
import React, { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { Container, CardBody, Card } from "reactstrap"
import * as XLSX from "xlsx"
import moment from "moment"

const InvoicePaymentReport = () => {
  const [invoicing_options, setinvoicing_options] = useState([])
  const [payment_options, setpayment_options] = useState([])
  const [invoiceMethod, setInvoiceMethod] = useState("")
  const [paymentMethod, setPaymentMethod] = useState("")
  const [clients, setClients] = useState([])

  // getting dropdown options common function
  async function getOptions(api) {
    try {
      const response = await axiosbaseurl.get(`/${api}/active`)
      if (response.data.success) return response.data.data

      return false
    } catch (error) {
      console.log(error)
    }
  }

  // getting dropdown options
  useEffect(() => {
    ;(async () => {
      try {
        let options = []

        options = await getOptions("invoicing-method")
        setinvoicing_options(options || [])

        options = await getOptions("payment-method")
        setpayment_options(options || [])
      } catch (error) {
        console.log(error)
      }
    })()
  }, [])

  useEffect(() => {
    if (invoiceMethod || paymentMethod) {
      ;(async () => {
        try {
          const response = await axiosbaseurl.post(`/reports/inv-pay/report`, {
            invoicingMethodId: invoiceMethod,
            paymentMethodId: paymentMethod,
          })

          setClients(response.data.clients || [])
        } catch (error) {
          console.log(error)
        }
      })()
    } else {
      setClients([])
    }
  }, [invoiceMethod, paymentMethod])

  const handleExportToExcel = () => {
    if (!clients.length) {
      swal("", "No clients available to export", "warning")
      return
    }

    const exportData = clients.map((client, index) => ({
      ["Serial No."]: index + 1,
      ["Client Code"]: client?.clientCode || "--",
      ["Client Name"]: client?.clientName || "--",
    }))

    // Create a worksheet, but shift client data to start at row 4 (leave a blank row at 3)
    const ws = XLSX.utils.json_to_sheet(exportData, { origin: "A4" })

    // Add report header at the top
    XLSX.utils.sheet_add_aoa(
      ws,
      [
        ["Invoicing Method & Payment Method Report"],
        [],
        [
          `Generated On: ${moment().format("DD-MM-YYYY HH:mm:ss")}`,
          "",
          `Invoicing Method: ${
            invoicing_options.find(opt => opt.id === parseInt(invoiceMethod))
              ?.invoicingMethod || "All"
          }`,
          `Payment Method: ${
            payment_options.find(opt => opt.id === parseInt(paymentMethod))
              ?.paymentMethod || "All"
          }`,
        ],
      ],
      { origin: "A1" }
    )

    // Auto column width
    const colWidths = Object.keys(exportData[0]).map(key => ({
      wch: Math.max(
        key.length,
        ...exportData.map(row => String(row[key]).length)
      ),
    }))
    ws["!cols"] = colWidths

    // Create workbook and append sheet
    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, "Invoice_Payment_Report")

    // Save file
    XLSX.writeFile(
      wb,
      `Invoice_Payment_Report-(${moment().format("DD-MM-YYYY_HH-mm-ss")}).xlsx`
    )
  }

  return (
    <div>
      <div className="page-content mb-5">
        <Container fluid>
          <Breadcrumb
            title={"Dashboard"}
            breadcrumbItem={"Invoice & Payment Report"}
          />
          <div>
            <Card>
              <CardBody>
                <div className="pb-3 d-flex justify-content-end align-items-center">
                  <button
                    className="btn btn-primary"
                    onClick={handleExportToExcel}
                  >
                    Export Data
                  </button>
                </div>
                <div className="row mb-3 ">
                  <div className="col-md-3 mb-3">
                    <label>
                      Invoicing Method <span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-select input-field"
                      value={invoiceMethod}
                      onChange={e => setInvoiceMethod(e.target.value)}
                    >
                      <option value="">Select Invoicing method</option>
                      {invoicing_options
                        ?.slice()
                        .sort((a, b) =>
                          a.invoicingMethod.localeCompare(b.invoicingMethod)
                        )
                        ?.map(option => (
                          <option key={option.id} value={option.id}>
                            {option.invoicingMethod}
                          </option>
                        ))}
                    </select>
                  </div>

                  <div className="col-md-3 mb-3">
                    <label>
                      Payment Method <span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-select input-field"
                      value={paymentMethod}
                      onChange={e => setPaymentMethod(e.target.value)}
                    >
                      <option value="">Select Payment Method</option>
                      {payment_options
                        ?.slice()
                        .sort((a, b) =>
                          a.paymentMethod.localeCompare(b.paymentMethod)
                        )
                        ?.map(option => (
                          <option key={option.id} value={option.id}>
                            {option.paymentMethod}
                          </option>
                        ))}
                    </select>
                  </div>

                  <div className="col-md-6 mb-3">
                    <table className="table">
                      <thead className="table-primary">
                        <tr>
                          <td>Client Name & Code</td>
                          <td className="col-3">Action</td>
                        </tr>
                      </thead>

                      <tbody>
                        {clients.map(client => (
                          <tr key={client.id}>
                            <td>
                              {client.clientName} -{" "}
                              <span className="text-primary">
                                {client.clientCode}
                              </span>
                            </td>
                            <td>
                              <Link
                                to={`${app_url}edit-client/${client.id}?tab=3`}
                                target="_blank"
                                className="btn btn-outline-primary btn-sm"
                              >
                                <i className="fas fa-eye me-1"></i> See details
                              </Link>
                            </td>
                          </tr>
                        ))}

                        {!clients.length && (
                          <tr className="text-center">
                            <td colSpan={2}> No Clients Available!</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </CardBody>
            </Card>
          </div>
        </Container>
      </div>
    </div>
  )
}

export default InvoicePaymentReport
